import React, { useState, useContext } from "react";
import Modal from "./Modal";
import DateSelect from "./DateSelect";
import { Context } from "..";
import { MonthsAbr } from "./dateConstants";
import { useTranslation } from "react-i18next";

const Events = () => {
  const [modalOpened, setModalOpened] = useState(false);
  const { events } = useContext(Context);

  const now = new Date();
  const [date, setDate] = useState({
    day: now.getDate(),
    computerMonth: now.getMonth(),
    year: now.getFullYear(),
  });

  const dateChange = React.useCallback(
    (arg: { day: number; computerMonth: number; year: number }) => {
      setDate(arg);
    },
    []
  );

  const [newEventName, setNewEventName] = useState("");
  const [newEventFreq, setNewEventFreq] = useState<
    "ONCE" | "MONTHLY" | "YEARLY"
  >("ONCE");

  const formValid = newEventName.length > 0;
  const btnClassName = formValid
    ? "px-16 py-2 rounded-xl border bg-green-600 text-white mr-4"
    : "px-16 py-2 rounded-xl border bg-gray-600 text-white mr-4 cursor-not-allowed";

  const submit = () => {
    events[1]((events) => [
      {
        id: "EVENT_" + Math.round(Math.random() * 100000000) + "",
        name: newEventName,
        date: new Date(date.year, date.computerMonth, date.day),
        frequency: newEventFreq,
      },
      ...events,
    ]);

    setModalOpened(false);
  };

  const { t } = useTranslation();

  return (
    <>
      <h1 className="text-3xl mt-10 mb-4">📆 {t("Events")}</h1>
      <div className="mt-2 grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-4 mb-10">
        <div
          onClick={() => setModalOpened((v) => !v)}
          className="cursor-pointer p-10 bg-transparent border-dashed border border-gray-500 flex rounded-xl items-center justify-center"
        >
          + {t("Add Event")}
        </div>
        {events[0].map((e) => (
          <div
            key={e.id}
            className="shadow-md hover:shadow-xl p-10 bg-gray-50 rounded-xl "
          >
            <h1 className="text-3xl text-center mb-4">{e.name}</h1>
            <h2 className="text-md text-center text-gray-600">
              {e.frequency === "ONCE"
                ? "Once"
                : e.frequency === "MONTHLY"
                ? "Each month"
                : "Each year"}
            </h2>
            <h3 className="text-sm text-center text-gray-400 font-semibold">
              {e.frequency === "ONCE"
                ? `${e.date.getDate()}. ${
                    MonthsAbr[e.date.getMonth()]
                  } ${e.date.getFullYear()}`
                : `${e.date.getDate()}. ${MonthsAbr[e.date.getMonth()]}`}
            </h3>
          </div>
        ))}

        {modalOpened && (
          <Modal onClose={() => setModalOpened(false)}>
            <div className="p-10">
              <h1 className="text-3xl mb-5">Add Event</h1>
              <div>
                <div>Event name</div>
                <input
                  value={newEventName}
                  onChange={(e) => setNewEventName(e.target.value)}
                  type="text"
                  className="rounded-md border p-2 w-6/12 border-gray-400"
                  placeholder="Name"
                />
              </div>
              <div className="my-4">
                <div>Event date</div>
                <DateSelect value={date} onChange={dateChange} />
              </div>
              <div className="my-4">
                <div>Frequency</div>
                <select
                  value={newEventFreq}
                  onChange={(e) =>
                    setNewEventFreq(
                      e.target.value as "ONCE" | "MONTHLY" | "YEARLY"
                    )
                  }
                  placeholder="Frequency"
                  className="border py-1 px-3 rounded-md border-gray-400"
                >
                  <option value="ONCE">Once</option>
                  <option value="MONTHLY">Every Month</option>
                  <option value="YEARLY">Every Year</option>
                </select>
              </div>

              <div className="mt-10">
                <button
                  onClick={submit}
                  className={btnClassName}
                  disabled={!formValid}
                >
                  Add
                </button>
                <button
                  className="px-10 py-2 rounded-xl border border-gray-400"
                  onClick={() => setModalOpened(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </>
  );
};

export default Events;
